/**
 * Custom select
 * @requires https://github.com/Choices-js/Choices
*/

import Choices from 'choices.js';

const customSelect = (() => {

  let select = document.querySelectorAll('.custom-select');

  for (let i = 0; i < select.length; i++) {

    let isSearchable = select[i].dataset.searchable ? true : false;

    new Choices(select[i], {
      searchEnabled: isSearchable,
      searchChoices: isSearchable,
      searchPlaceholderValue: 'Search...',
      shouldSort: false,
      allowHTML: true
    });
  }

  return true;

})();

export default customSelect;
